import Popover from "patient-ping-remedy/packages/popover";
import React, {useState} from "react";
import Avatar from "@common/Avatar";
import {Roster, User} from "@/api/dto/dto";
import PopoverAvatarDetails from "@common/PopoverAvatarDetails";
import {css} from "@emotion/css";
import {sizes} from "patient-ping-remedy/packages/theme";

type Props = {
  user?: Partial<User> | null;
  roster?: Roster | null;
  description?: string;
}
const AvatarDetails = (props: Props) => {
  const [detailsOpen, setDetailsOpen] = useState<boolean>(false);

  return (
    <div onMouseEnter={() => setDetailsOpen(true)} onMouseLeave={() => setDetailsOpen(false)}>
      <Popover
        position="left"
        toggle={() => setDetailsOpen(!detailsOpen)}
        isOpen={detailsOpen}
        content={<PopoverAvatarDetails user={props.user!} roster={props.roster} />}
      >
        <Avatar user={props.user} />
        {props.description && <span className={css({marginLeft: sizes.xSmall})}>{props.description}</span>}
      </Popover>
    </div>
  );
};

export default AvatarDetails;
